import React, {useState} from "react";
import {
    Box, Button, IconButton, Paper, Stack, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {toastHelper} from "../../../../utils/toast-helper.js";
import {useCreateElementMutation, useDeleteElementMutation} from "../../../../modules/actes/actes.api.js";

/**
 * Gestion des zones (ElementMaintenance) d'un acte CHECKLIST. Chaque zone est une
 * ressource autonome (add/remove live). Disponible en édition.
 */
export default function ElementMaintenanceField({acteId, elements = []}) {
    const [createElement, {isLoading: creating}] = useCreateElementMutation();
    const [deleteElement] = useDeleteElementMutation();

    const [code, setCode] = useState("");
    const [libelleFr, setLibelleFr] = useState("");
    const [libelleAr, setLibelleAr] = useState("");
    const [conteneurType, setConteneurType] = useState("");

    const reset = () => {
        setCode("");
        setLibelleFr("");
        setLibelleAr("");
        setConteneurType("");
    };

    const handleAdd = async () => {
        if (!code || !libelleFr) return;
        try {
            await createElement({
                acteId,
                acte: `/actes/${acteId}`,
                code,
                libelleFr,
                libelleAr: libelleAr || null,
                conteneurType: conteneurType || null,
                ordre: elements.length + 1,
            }).unwrap();
            toastHelper.displaySuccess("Zone ajoutée.");
            reset();
        } catch (e) {
            toastHelper.handleError(e, "Oops, une erreur est survenue lors de l'ajout de la zone.");
        }
    };

    const handleDelete = async (el) => {
        try {
            await deleteElement({id: el.id, acteId}).unwrap();
            toastHelper.displaySuccess("Zone supprimée.");
        } catch (e) {
            toastHelper.handleError(e, "Oops, une erreur est survenue lors de la suppression.");
        }
    };

    return (
        <Box className={"sectionContainer"} sx={{mt: 3}}>
            <Typography variant={"h5"} className={"sectionHeader"}>Zones à inspecter</Typography>

            <TableContainer component={Paper} className={"mt-2"}>
                <Table size="small">
                    <TableHead>
                        <TableRow className={"tableHeader-row"}>
                            <TableCell>Ordre</TableCell>
                            <TableCell>Code</TableCell>
                            <TableCell>Libellé (FR)</TableCell>
                            <TableCell>Libellé (AR)</TableCell>
                            <TableCell>Type conteneur</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {elements.length === 0 &&
                            <TableRow><TableCell colSpan={6} align="center">Aucune zone</TableCell></TableRow>
                        }
                        {[...elements].sort((a, b) => (a.ordre || 0) - (b.ordre || 0)).map((el) => (
                            <TableRow key={el.id} hover>
                                <TableCell>{el.ordre}</TableCell>
                                <TableCell>{el.code}</TableCell>
                                <TableCell>{el.libelleFr}</TableCell>
                                <TableCell dir="rtl">{el.libelleAr}</TableCell>
                                <TableCell>{el.conteneurType || "—"}</TableCell>
                                <TableCell align="center">
                                    <IconButton color="error" onClick={() => handleDelete(el)}><Delete/></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Stack direction={{xs: "column", md: "row"}} spacing={2} alignItems={{md: "center"}} sx={{mt: 2}}>
                <TextField label="Code" value={code} onChange={(e) => setCode(e.target.value)} size="small"/>
                <TextField label="Libellé (FR)" value={libelleFr} onChange={(e) => setLibelleFr(e.target.value)} size="small"/>
                <TextField label="Libellé (AR)" value={libelleAr} onChange={(e) => setLibelleAr(e.target.value)} size="small" dir="rtl"/>
                <TextField label="Type conteneur" value={conteneurType} onChange={(e) => setConteneurType(e.target.value)} size="small"/>
                <Button variant="contained" onClick={handleAdd} disabled={!code || !libelleFr || creating}>
                    Ajouter la zone
                </Button>
            </Stack>
        </Box>
    );
}
